import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./sass/main.scss";
import "./css/emoji.css";

import { createI18n } from "@/i18n/index";
const i18n = createI18n(store.state.translation.locale).i18n;

import Axios from "./services/axios";
Vue.prototype.$http = Axios;

Vue.config.productionTip = false;

import MasonryWall from '@yeger/vue2-masonry-wall'
Vue.use(MasonryWall)

export const app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  render: h => h(App)
}).$mount("#app");
